import { Recurso } from "lib.common/dist/CleanArch";
import { AbonosPasarelaDtSource } from "../../bussines/dataSources/AbonosPasarelaDtSource";
import { Pago, PagoDetalle } from "../../bussines/entities/Pago";
import { GetDetallesAbonoParams, GetSomeAbonosPasarelaParams } from "../../utils/params/GetSomeAbonosPasarelaParams";
import { ErrExterno } from "lib.common/dist/errorHandler";
import { transformacion } from "lib.common/dist";
import { apiDsTienda } from "src/config/keys";
import { format } from "date-fns";

export class AbonosPasarelaDtSourceImplRest implements AbonosPasarelaDtSource {
    async getSomeAbonosPasarela(input: GetSomeAbonosPasarelaParams): Promise<Recurso<Pago[]>> {
        try {
            const { cliente, fechaIni, fechaFin, estado } = input;
            let url = transformacion.appendUrl(apiDsTienda, '/gestionPagos/pago/RepPagoAbonos');
            const params = new URLSearchParams();
            if (cliente) params.append('pIdCliente', cliente.toString());
            if (fechaIni) params.append('pFechaInicial', format(fechaIni, 'yyyy-MM-dd'));
            if (fechaFin) params.append('pFechaFinal', format(fechaFin, 'yyyy-MM-dd'));
            if (estado) params.append('pEstadoPago', estado);
            url.search = params.toString();
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición de abonos en tienda.');
            }

            const { data } = await response.json();
            return Recurso.fromData<Pago[]>(data);

        } catch (error) {
            return Recurso.fromError<Pago[]>(new ErrExterno(error as Error));
        }
    }

    async  getDetallesAbono(input: GetDetallesAbonoParams): Promise<Recurso<PagoDetalle[]>> {
        try {
            const { idPago } = input;
            let url = transformacion.appendUrl(apiDsTienda, `/gestionPagos/pago/pagoDetalle/${idPago.toString()}`);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición de abonos en tienda.');
            }

            const { data } = await response.json();
            return Recurso.fromData<PagoDetalle[]>(data);

        } catch (error) {
            return Recurso.fromError<PagoDetalle[]>(new ErrExterno(error as Error));
        }
    }
}